import React, { Component } from "react";
import {
    Row,
    Col,
    FormGroup,
    ControlLabel,
    FormControl,
    Alert
  } from "react-bootstrap";
import moment from "moment";
import DatePicker from "react-datepicker";
import { Card } from "components/Card/Card.jsx";
import Button from "components/CustomButton/CustomButton.jsx";

import { fetchHolidayRequest, createHolidayRequest, editHolidayRequest } from "../../../api/holiday";
import { areaSelectOptionRequest } from "../../../api/area";

import { 
  holidayTypeSelectOptions
} from "../../../variables/Variables.jsx";

class HolidaysForm extends Component {

  constructor(props) {
    super(props);
    this.state = {
      resource: {
        holidayDate: '',
        holidayType: '',
        area: ''
      },
      areaSelectOptions: [],
      error: null
    }
  }

  componentDidMount() {
    const { instanceId } = this.props;

    if (instanceId) {
      this.fetchInstance(instanceId);
    } 

    areaSelectOptionRequest(
      result => this.setState({ areaSelectOptions: result }),
      error => this.setState({ error: "There was an error" })
    );
  }

  fetchInstance = (id) => {
      fetchHolidayRequest(id,
          result => this.setState(prevState => ({
              resource: {
                  ...prevState.resource,
                  ...result
              }
          })), error => this.setState({ error: 'There was an error' }));
  }

  handleFormChange = (e) => {
    const { target } = e;
    const { name, value } = target;

    this.setState(prevState => ({
      resource: {
        ...prevState.resource,
        [name]: value,
      },
    }))
  }

  onChangeDate = (date, field) => {
    let value = moment(date).format("YYYY-MM-DD");

    this.setState(prevState => ({
      resource: {
        ...prevState.resource,
        [field]: value
      }
    }));
  };

  save = () => {
    const {
      holidayDate,
      holidayType,
      area
    } = this.state.resource;

    const {
      instanceId
    } = this.props;

    const isNewRecord = !instanceId;

    let data = {
      holidayDate,
      holidayType,
      area
    };

    if (isNewRecord) {
        createHolidayRequest(data,
            result => this.saveSuccess(),
            error => this.saveFailure(error)
        );
    } else {
        editHolidayRequest(instanceId, data,
            result => this.saveSuccess(),
            error => this.saveFailure(error)
        );
    }
  }

  saveSuccess = () => {
    this.setState({ error: null });
    this.props.goToList('holidays');
  }

  saveFailure = (error) => {
      this.setState({ error: error.message || 'There was an error saving Holiday.' })
  }

  render() {

    const {
      holidayType,
      area
    } = this.state.resource;

    const {
      areaSelectOptions,
      error
    } = this.state;

    const holidayDate = this.state.resource.holidayDate ? moment(this.state.resource.holidayDate, 'YYYY-MM-DD').toDate() : '';

    const {
      instanceId
    } = this.props;

    const isNewRecord = !instanceId;

    return (
      <Row>
        <Col md={12}>
          <Card
            title={isNewRecord ? "New entry" : "Edit entry"}
            content={
              <form>
                <Button className="card-top-btn btn-primary" onClick={() => this.props.goToList('holidays')}>
                  Back to List
                </Button>
                <FormGroup>
                  <ControlLabel>Holiday Date</ControlLabel>
                  <DatePicker
                    selected={holidayDate}
                    onChange={(date) => this.onChangeDate(date,'holidayDate')}
                    dateFormat="MM/dd/yyyy"
                    className="dateInput"
                    dropdownMode="select"
                  />
                </FormGroup>
                <FormGroup controlId="formControlsSelect">
                  <ControlLabel>Holiday Type</ControlLabel>
                  <FormControl 
                      onChange={this.handleFormChange}
                      componentClass="select" 
                      name="holidayType"
                      value={holidayType}
                    >
                    <option value="">Select</option>
                    {holidayTypeSelectOptions.map(option => {
                      return (
                        <option
                          key={option.value}
                          value={option.value}
                        >
                          {option.label}
                        </option>
                      );
                    })}
                  </FormControl>
                </FormGroup>
                <FormGroup controlId="formControlsSelect">
                  <ControlLabel>Area</ControlLabel>
                  <FormControl 
                      onChange={this.handleFormChange}
                      componentClass="select" 
                      name="area"
                      value={area}
                    >
                    <option value="">Select</option>
                    <option value="All">All</option>
                    {/* <option value="All">All</option> */}
                    {areaSelectOptions.map(option => {
                      return (
                        <option
                          key={option.value}
                          value={option.value}
                        >
                          {option.label}
                        </option>
                      );
                    })}
                  </FormControl>
                </FormGroup>
                {error &&
                  <Alert bsStyle="danger">
                    {error}
                  </Alert>
                }
                <Button bsStyle="primary" pullRight fill onClick={this.save}>
                  {isNewRecord ? "Create" : "Save changes"}
                </Button>
                <div className="clearfix" />
              </form>
            }
          />
        </Col>
      </Row>
    )
  }
}

export default HolidaysForm;
